<template>
  <v-menu v-model="open" offset-y :close-on-content-click="false" content-class="brand-color-menu">
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        :label="label"
        :rules="[colorRule]"
        dense
        outlined
        hide-details="auto"
        v-on="on"
        @input="onTextInput"
      >
        <template #prepend-inner>
          <span class="brand-color-swatch" :style="{ backgroundColor: value }" />
        </template>
        <template #append>
          <v-icon small>mdi-eyedropper-variant</v-icon>
        </template>
      </v-text-field>
    </template>

    <v-card outlined class="brand-color-picker-card">
      <v-color-picker
        :value="value"
        mode="hexa"
        show-swatches
        swatches-max-height="120"
        width="300"
        @input="onPickerInput"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="open = false">Concluir</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "BrandColorPicker",
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
  },
  data: () => ({ open: false }),
  methods: {
    colorRule(value) {
      return /^#[0-9a-f]{6}$/i.test(value || "") || "Use o formato #RRGGBB";
    },
    normalize(value) {
      const color = typeof value === "string" ? value : value && value.hex;
      if (!color) return this.value;
      return color.slice(0, 7).toUpperCase();
    },
    onTextInput(value) {
      this.$emit("input", value);
    },
    onPickerInput(value) {
      this.$emit("input", this.normalize(value));
    },
  },
};
</script>

<style scoped>
.brand-color-picker-card { border-radius: 8px; overflow: hidden; }
.brand-color-swatch { border: 1px solid rgba(15, 23, 42, .14); border-radius: 4px; display: inline-block; height: 20px; margin: 2px 8px 0 0; width: 20px; }
</style>
